import { styled } from "@linaria/react";

import { withTheme } from "../theme/GalaxyTheme";
import type { PropsWithTheme } from "../theme/types";

import Text, { TextWeight } from "../text/Text";

const StyledSwitcher = withTheme(styled.div<PropsWithTheme>`
  display: flex;
  flex-direction: row;
  align-items: center;

  background: ${({ theme }) => theme.color.background.primary};
  border: 0.5px solid ${({ theme }) => theme.color.border.primary};
  border-radius: 5px;

  padding: 0 3px;
  height: 28px;
`);

const SwitcherItem = withTheme(styled.div<PropsWithTheme & { $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 3px 8px;

  background: ${({ theme, $isSelected }) =>
    $isSelected ? theme.color.background.secondary : "transparent"};

  cursor: pointer;

  border: 0.5px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.color.border.primary : "transparent")};
  border-radius: 4px;
`);

export interface SwitcherItem {
  id: string;
  label: string;
  onClick: () => void;
}

interface SwitcherProps {
  items: SwitcherItem[];
  selectedId: string;
}

const Switcher = ({ items, selectedId }: SwitcherProps) => {
  return (
    <StyledSwitcher>
      {items.map((item) => (
        <SwitcherItem key={item.label} onClick={item.onClick} $isSelected={item.id === selectedId}>
          <Text weight={TextWeight.MEDIUM} cursor="pointer">
            {item.label}
          </Text>
        </SwitcherItem>
      ))}
    </StyledSwitcher>
  );
};

export default Switcher;
